import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Image from "vino/components/Image";
import { FormattedAmount } from "vino/core";

const ProductListItem = ({ variant }) => {
	const navigate = useNavigate();
	const { product } = variant;

	const handleSubscribe = () => {
		navigate(`/subscription/product/${variant.id}`);
	};

	return (
		<div className="col w-full list-view-item p-5">
			<div className="card w-full shadow-sm mb-5">
				<div className="prodPic">
					<Image image={product} />
				</div>
				<div className="card-body px-10">
					<span className="dark list-item-title">{product.name}</span>
					<p className="card-text min-h-10">{product.description}</p>

					<div className="flex justify-content-between qrp-wrap pb-10">
						<div className="qr-details">
							<span className="prod-quantity">{variant.name}</span>
							<span className="prod-price">
								<FormattedAmount value={variant.price} />
							</span>
						</div>
						<button
							onClick={handleSubscribe}
							className="btn btn-primary action-btn"
						>
							<div className="add-prod flex w-full justify-center">
								<span>Subscribe Now</span>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

ProductListItem.propTypes = {
	variant: PropTypes.object.isRequired,
};

export default ProductListItem;
